import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { NewRelicService } from '@core/observability/newrelic/newrelic.service';
import { catchError, EMPTY } from 'rxjs';

export function provideNewRelic(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const newRelicService = inject(NewRelicService);
      return newRelicService.init().pipe(
        catchError(err => {
          console.error('Unable to initialize New Relic', err);
          return EMPTY;
        })
      );
    })
  ])
}
